import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("qp_token");
      if (!window.location.pathname.startsWith("/masuk") && !window.location.pathname.startsWith("/daftar")) {
        window.location.href = "/masuk";
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Terjadi kesalahan. Coba lagi.") =>
  e?.response?.data?.detail || fallback;

export default api;
